import MRequest from "../../modules/MRequest";
import MDiaryDay from "./MDiaryDay";
import MDiaryDaySection from "./MDiaryDaySection";

export default class MDiaryDayEntry
{
	constructor(el)
	{
		this.el = el;
	}

	static selector = () => `.profile-entry`;

	static addEventListeners()
	{
		document.addEventListener("change", (event) => {
			if (event.target.matches(`.profile-entry__checkbox-input`)) {
				let input = event.target;
				let entry = new MDiaryDayEntry(event.target.closest(this.selector()));
				input.checked ? entry.setChecked() : entry.unsetChecked();
			}
		});
	}

	getDiaryDay()
	{
		return new MDiaryDay(this.el.closest(".diary-day"));
	}

	getSection()
	{
		return new MDiaryDaySection(this.el.closest(".profile-diary-day-section"));
	}

	getObjectId()
	{
		return parseInt(this.el.dataset.id);
	}

	getDeleteUrl()
	{
		return this.el.dataset.deleteUrl;
	}

	hide()
	{
		this.el.setAttribute("hidden", "");
	}

	show()
	{
		this.el.removeAttribute("hidden");
	}

	setProcessing()
	{
		this.el.dataset.processing = 1;
	}

	unsetProcessing()
	{
		this.el.dataset.processing = 0;
	}

	isProcessing()
	{
		return this?.el?.dataset?.processing == 1;
	}

	delete()
	{
		const diaryDay = this.getDiaryDay();
		const url = this.getDeleteUrl();
		const data = {
			objectId: this.getObjectId(),
		}

		this.el.remove();
		diaryDay.refreshProgramMeals();

		MRequest.post(url, data).then(response => {
			if (response.data?.templates?.sidebar || false) {
				diaryDay.getSidebar().setHtml(response.data.templates.sidebar);
			}
		});
	}

	setChecked()
	{
		this.el.classList.add("profile-entry--checked");
	}

	unsetChecked()
	{
		this.el.classList.remove("profile-entry--checked");
	}
}
